import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { OrganizationAdminComponent } from './organization-admin.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { OrgDetailsComponent } from './components/org-details/org-details.component';
import { OrgViewComponent } from './components/org-view/org-view.component';



const routes: Routes = [
  {
    path: '', component:OrganizationAdminComponent,children:[
       {
         path:'',
         component: OrgDetailsComponent
       
       },
      //  {
      //   path:'dashboard',component: DashboardComponent
      //  },
      {
        path: 'details', 
        component:OrgDetailsComponent,
        data:{
          breadcrumb: 'Details',
         }
      },
      {
        path: 'view/:id', 
        component:OrgViewComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OrganizationAdminRoutingModule { }